import { useEffect, useState } from "react";
import { connect } from "react-redux";
import TextOptions from "./TextOptions";

import ValueSlider from "./ValueSlider";
import OneToTenOptions from "./OneToTenOptions";
import { SetAnswer } from "../../../redux/v2/user/actions";

function SurveyCard(props) {
    const { survey, index, setEnableNext } = props;
    const { account } = props.User;
    const latestSurvey = account?.survey?.answers?.length ? account?.survey?.answers[account?.survey?.answers?.length - 1] : null;

    const [rangeValue, setRangeValue] = useState(
        survey?.answer
            ? survey.answer
            : survey?.question_type == 2 ? "" : ""
    );
    const [isRadioChecked, setRadioChecked] = useState(false);

    useEffect(() => {
        if (rangeValue) {
            setEnableNext(true);
            props.SetAnswer(survey, index, rangeValue);
        }
    }, [rangeValue]);

    const title = survey.title.toUpperCase();

    return (
        <div className="gs-v2-survey-card">
            <div>
                <h4>
                    {
                        (title == "PERCEIVED HEALTH" ? "MENTAL HEALTH" : title)
                    }
                </h4>
                <body>{survey.question}</body>
            </div>

            <div className="flex-c">
                {survey.question_type == 2 && (
                    // <ValueSlider
                    //     setHealthRate={(value) => {
                    //         setRangeValue(value);
                    //     }}
                    //     options={survey.options}
                    //     startValue={survey.start_value}
                    //     endValue={survey.end_value}
                    //     value={rangeValue}
                    //     healthvalue={5}
                    //     onChange={(e) => {
                    //         setRangeValue(e.target.value);
                    //     }}
                    // />
                    <OneToTenOptions
                        latestSurvey={latestSurvey}
                        previous={survey?.latestAnswer}
                        value={rangeValue}
                        onChange={(val) => {
                            setRangeValue(val);
                        }}
                    />
                )}
                {survey.question_type == 1 && (
                    <TextOptions
                        setValue={(value) => {
                            setRangeValue(value);
                            setRadioChecked(true);
                        }}
                        default={rangeValue}
                        options={survey.options.split(",")}
                        previous={survey?.latestAnswer}
                        latestSurvey={latestSurvey}
                    />
                )}
            </div>
        </div>
    );
}


const mapStateToProps = (state) => ({
    User: state.User
});

export default connect(mapStateToProps, {
    SetAnswer,
})(SurveyCard);
